<template>
	<PrimeChart v-if="chartData" type="line" :data="chartData" :options="chartOptions" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";

import PrimeChart from "primevue/chart";

import { supabase } from "@/ts/supabase";

export default defineComponent({
	name: "StatsMonthlyImagesCountChart",
	components: {
		PrimeChart
	},
	props: {
		chartOptions: {
			type: Object,
			required: true
		}
	},
	setup() {
		const chartData = ref();

		onMounted(async () => {
			const { data, error } = await supabase.rpc("stats_get_monthly_image_stats");

			if (error) {
				console.error(error);
				return;
			}

			chartData.value = {
				labels: data.map((entry) => entry.month),
				datasets: [
					{
						label: "Images",

						data: data.map((entry) => entry.image_count),
						fill: true,
						borderWidth: 1,
						pointStyle: "circle",
						pointRadius: 5,
						pointHoverRadius: 10,
						cubicInterpolationMode: "monotone"
					}
				]
			};
		});

		return {
			chartData
		};
	}
});
</script>
